module.exports = "<p ng-repeat=\"gallery in $ctrl.data\">\r\n    <a style=\"float:right; margin-left: 8px\" ng-href=\"/gallery/{{gallery._id}}\" class=\"btn btn-sm btn-more\"><i class=\"fa fa-arrow-circle-right\"></i> more</a>\r\n    <b>{{gallery.title}}</b><br/><em ng-bind-html=\"$ctrl.getPreviewText(gallery.description)\"></em>\r\n</p>"


//////////////////
// WEBPACK FOOTER
// ./client/components/sidebar/galleries-widget/galleries-widget.component.html
// module id = 606
// module chunks = 0